export default class KeyHelper {
    static isLetter(e) {
        return e.key && e.key.match(/(\w|\s)/g) && e.key.length === 1;
    }

    static isDelete(e) {
        return e.key && (e.key === 'Backspace' || e.key === 'Delete');
    }

    static isTab(e) {
        return e.key === 'Tab' && ! e.shiftKey;
    }

    static isShiftTab(e) {
        return e.key === 'Tab' && e.shiftKey;
    }

    static isEsc(e) {
        return e.key === 'Escape';
    }

    static isEnter(e) {
        return e.key === 'Enter';
    }

    static isArrowUp(e) {
        return e.key === 'ArrowUp';
    }

    static isArrowDown(e) {
        return e.key === 'ArrowDown';
    }
}
